import RuleModal from "./RuleModal";
export default RuleModal;
